import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { PropTypes } from '@amzn/stencil-react-desc';
import { styledWithTheme } from "../context";
import { A11Y_MIN_SIZE, filterPropsFromPropTypes } from "../utils";
import { BORDER_RADIUS, BORDER_WIDTH } from "./constants";
import { iconOnlyStyles } from "./iconOnlyStyles";
import { ButtonColorScheme, ButtonIconPosition, ButtonSize, ButtonVariant } from "./interfaces";
import { responsiveStyles } from "./responsiveStyles";
import { variantStyles } from "./variantStyles";
export var ButtonBasePropTypes = {
  colorScheme: PropTypes.oneOf(Object.values(ButtonColorScheme)).description('Selects a predefined color scheme to use for the component.'),
  icon: PropTypes.node.description('Adds an icon on the leading or trailing side of the button.'),
  iconPosition: PropTypes.oneOf(Object.values(ButtonIconPosition)).description('Determines on which side the icon would be placed.'),
  isDestructive: PropTypes.bool.description('Change the style of the button to indicate that it performs a destructive action.'),
  shouldUseResponsiveContent: PropTypes.bool.description("Indicates whether the button's content parameters ('padding', 'font-size', 'line-height') should be changing based on the breakpoints in the theme."),
  size: PropTypes.oneOf(Object.values(ButtonSize)).description('Specifies what size of the button should be used.'),
  variant: PropTypes.oneOf(Object.values(ButtonVariant)).description('The type of button that determines its visual style.')
};
export var ButtonBase = styledWithTheme('button', {
  shouldForwardProp: filterPropsFromPropTypes(ButtonBasePropTypes, {
    filterInvalidHTML: true
  })
})(function (_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  // Keep disabled styling even if only aria-disabled passed
  if (props['aria-disabled'] && !props.disabled) {
    props.disabled = true;
  }

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, variantStyles(props, theme)), responsiveStyles(props, theme)), iconOnlyStyles(props)), {}, {
    alignItems: 'center',
    borderRadius: BORDER_RADIUS,
    borderStyle: 'solid',
    borderWidth: "".concat(BORDER_WIDTH, "px"),
    boxShadow: 'none',
    boxSizing: 'border-box',
    cursor: !!props.disabled ? 'not-allowed' : 'pointer',
    display: 'flex',
    fontFamily: theme.selectors.fontFamily('primary'),
    fontWeight: theme.selectors.fontWeight('medium'),
    justifyContent: 'center',
    minHeight: "".concat(A11Y_MIN_SIZE, "px"),
    outline: 'none',
    position: 'relative',
    textAlign: 'center',
    transition: 'background-color .2s ease 0s, border-color .2s ease 0s',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    ':focus:before': {
      content: '""',
      position: 'absolute',
      top: "-".concat(2 * BORDER_WIDTH + 1, "px"),
      bottom: "-".concat(2 * BORDER_WIDTH + 1, "px"),
      left: "-".concat(2 * BORDER_WIDTH + 1, "px"),
      right: "-".concat(2 * BORDER_WIDTH + 1, "px"),
      backgroundColor: 'transparent',
      borderRadius: BORDER_RADIUS,
      borderWidth: BORDER_WIDTH,
      borderStyle: 'solid',
      transition: 'border 0.2s ease 0s'
    }
  });
});